/**
 *
 * Text
 *
 */
import React from 'react';
import { useTheme } from 'styled-components';

interface TextProps {
  children: any;
  testid?: string | number;
  fontSize?: string;
  color?: string;
  lineHeight?: string;
  fontWeight?: string;
  className?: string;
}

export function Text(props: TextProps) {
  const {
    colors: {
      default: { darkGray },
    },
    fonts: {
      default: {
        fontSize: { ft14 },
        lineHeight: { text },
        fontWeight: { normal },
      },
    },
  } = useTheme();

  const {
    testid = 'text-test-id',
    children,
    fontSize = ft14,
    color = darkGray,
    lineHeight = text,
    fontWeight = normal,
    className,
  } = props;

  return (
    <span
      data-testid={testid}
      className={className}
      style={{
        fontSize,
        color,
        lineHeight,
        fontWeight: fontWeight,
      }}
    >
      {children}
    </span>
  );
}
